<template>
  <div>
      <section class="section-shaped my-0">
          <div class="shape shape-skew">
              <img src="/img/bkgrnd.jpg" class="img-fluid">
          </div>

            <div class="d-none d-lg-block container shape-container">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                          <img src="/img/devconf_logo_white_poly.png" width="100%">
                          <center><h1 style="color:white">{{talk.title}} - <i>{{talk.speaker}}</i></h1></center>
                        </div>
                    </div>
                </div>
            </div>

      </section>

      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5">
                              <div class="row" v-if="talk.stream">
                                <div class="col-lg-12">
                                  <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item"
                                      v-bind:src="'https://www.youtube.com/embed/' + talk.stream"
                                      frameborder="0"
                                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                      allowfullscreen>
                                    </iframe><br>
                                  </div>
                                  <br>
                                  <p v-html="talk.summary"></p>
                                  <center>
                                    <img v-bind:src="talk.picture" style="max-width:100%"/>
                                  </center>
                                </div>
                              </div>
                              <div v-else>
                                <p v-html="talk.summary"></p>
                                <center>
                                  <img v-bind:src="talk.picture" style="max-width:100%"/>
                                </center>
                              </div>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>
  </div>
</template>

<script>
import ProgrammaData from "@/data/ProgrammaData.js";

export default {
  data(){
    return {
      talk: {},
      countdown: "",
      pre: "",
      host: window.location.hostname
    }
  },
  mounted(){
    var year = this.$route.params.year;
    var index = this.$route.params.id;
    ProgrammaData.load(year).then(response => {
      this.talk = response.data[index];
    });
  }
}
</script>
